export default __webpack_public_path__ + "static/media/Facebook.045fe6e5.svg";